import { StyledSvg } from './Svg.styled';
import type { SizeProps } from './types';

export const MapIcon = ({ width, height }: SizeProps) => {
	return (
		<StyledSvg $width={width ?? '25px'} $height={height ?? '28px'} viewBox='0 0 25 28' fill='none'>
			<path
				d='M14.9206 22.7405L9.08969 20.6997L4.57074 22.449C4.2468 22.5786 3.94716 22.5421 3.67181 22.3397C3.39646 22.1372 3.25879 21.8659 3.25879 21.5258V7.92032C3.25879 7.70976 3.31953 7.5235 3.441 7.36153C3.56248 7.19956 3.7285 7.07808 3.93906 6.9971L9.08969 5.24783L14.9206 7.28864L19.4396 5.53937C19.7635 5.4098 20.0631 5.44624 20.3385 5.6487C20.6138 5.85116 20.7515 6.12246 20.7515 6.4626V20.068C20.7515 20.2786 20.6908 20.4649 20.5693 20.6268C20.4478 20.7888 20.2818 20.9103 20.0712 20.9913L14.9206 22.7405ZM13.9488 20.3596V8.98932L10.0615 7.62878V18.999L13.9488 20.3596ZM15.8924 20.3596L18.8079 19.3878V7.87173L15.8924 8.98932V20.3596ZM5.20242 20.1166L8.11788 18.999V7.62878L5.20242 8.6006V20.1166Z'
				fill='#008080'
			/>
		</StyledSvg>
	);
};
